export const colors = {
  black: '#000000',
  white: '#ffffff',
  grey: {
    10: '#F8FAFC',
    40: '#F1F5F9',
    50: '#E2E8F0',
    60: '#CBD5E1',
    70: '#94A3B8',
    100: '#CBD5E1',
    200: '#94A3B8',
    300: 'rgba(0,0,0,0.54)',
    350: '#94A3B8',
    400: '#64748B',
    600: '#475569',
    900: '#0F172A',
    999: '#020617',
  },
  blue: {
    200: '#0EA5E9',
    400: '#38BDF8',
    500: '#3B82F6',
    600: '#0F1729',
    700: '#0B1120',
  },
  pink: {
    600: '#0EA5E9',
  },
  red: {
    500: '#EF4444',
  },
  green: {
    500: '#10B981',
    1: '#06B6D4',
  },
  brown: {
    400: '#475569',
  },
  orange: {
    500: '#F59E0B',
  },
  yellow: {
    500: '#3B82F6',
  },
  violet: {
    600: '#06B6D4',
  },
  blueGrey: {
    700: '#0F1729',
    800: '#0B1120',
    900: '#020617',
  },
  transparent: 'transparent',
  blackRgba: {
    40: 'rgba(0,0,0, 0.04)',
    200: 'rgba(0, 0, 0, 0.20)',
    260: 'rgba(0, 0, 0, 0.26)',
    340: 'rgba(0, 0, 0, 0.34)',
    400: 'rgba(0, 0, 0, 0.40)',
    500: 'rgba(0, 0 , 0, 0.5)',
    540: 'rgba(0, 0, 0, 0.54)',
    600: 'rgba(0, 0 , 0, 0.6)',
    800: 'rgba(0, 0 , 0, 0.8)',
    870: 'rgba(0, 0, 0, 0.87)',
    900: 'rgba(0, 0 , 0, 0.9)',
  },
  whiteRgba: {
    800: 'rgba(248, 250, 252, 0.92)',
  },
  colorsRgba: {
    500: 'rgba(14, 165, 233, 0.12)',
    600: 'rgba(14, 165, 233, 0.15)',
  },
};

export const colorsLight = {
  primary: {
    main: colors.blue[200],
  },
};

export const colorsDark = {
  primary: {
    main: colors.pink[600],
  },
  secondary: {
    main: colors.violet[600],
  },
};

export const approvedAreaChartStyle = {
  colors: {
    corridorColor: '#6495ED',
    groundColor: '#B8860B',
    groundEdgeColor: '#006400',
  },
};

export const popupLoaderStyle = {
  color: '#0EA5E9',
};

export const utmStatusColors = {
  accepted: '#10B981',
  rejected: '#EF4444',
  verify: '#3B82F6',
};
